import { render, staticRenderFns } from "./SendBulkTutors.vue?vue&type=template&id=67f0ab6e&scoped=true"
import script from "./SendBulkTutors.vue?vue&type=script&lang=ts"
export * from "./SendBulkTutors.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f0ab6e",
  null
  
)

export default component.exports